import { Popup } from "@t8891/mobile";
import React, { useEffect, useState } from "react";
import { ISuperFrom } from "./SuperForm";
import { InquirySecondInformation, InquirySecondInformationOption } from "@legacy/types/bidding";
import { useSetState } from "ahooks";
import SelectItem from "./SelectItem";
import { itemIdValueEqual } from "utils/InquiryLogistics";

interface ICascaderPopup extends ISuperFrom {
  item: InquirySecondInformation["form"]["fields"][0];
  visible: boolean;
  onClose: () => void;
  parentItemId: number;
}

// 递归组件，用于渲染级联菜单的每一级
interface CascaderLevelProps {
  options: InquirySecondInformationOption[];
  onSelect: (option: InquirySecondInformationOption) => void;
  formParams: any;
  itemId: string;
  parentItemId: number;
}

const CascaderLevel: React.FC<CascaderLevelProps> = ({ formParams, options, onSelect, itemId, parentItemId }) => {
  console.log("🚀 ~ file: CascaderPopup.tsx:26 ~ itemId:", itemId);
  return (
    <div
      className='w-270 min-h-160 bg-white py-10 rounded-4'
      style={{
        boxShadow: "0px 4px 8px 0px rgba(0,0,0,0.10)",
      }}
    >
      {options?.map((option: InquirySecondInformationOption, index: number) => (
        <SelectItem
          key={index}
          press={itemIdValueEqual({ formParams, itemId: itemId, value: option.value })}
          onClick={(e) => {
            option.itemId = itemId;
            option.parentItemId = parentItemId;
            onSelect(e, option);
          }}
          label={option.label}
          arrow={option?.children && Object.keys(option?.children).length > 0}
        />
      ))}
    </div>
  );
};

const CascaderPopup: React.FC<ICascaderPopup> = ({ visible, onClose, parentItemId, item, onChange, formParams }) => {
  // 存储选择路径的状态
  const [selectionPath, setSelectionPath] = useState<InquirySecondInformationOption[]>([]);

  // 处理选择事件
  const handleSelect = (e, level: number, option: InquirySecondInformationOption) => {
    // 截断当前级别之后的选择
    const newPath = [...selectionPath.slice(0, level), option];
    setSelectionPath(newPath);

    // 如果是最后一级（没有子选项），则触发onChange
    if (!option.children || !option.children.options || option.children.options.length === 0) {
      onChange(e, newPath);
      onClose(e);
    }
  };

  // 初始化時檢查是否有選中項，並自動展開
  useEffect(() => {
    if (visible && formParams && item.options) {
      // 尋找第一級選中項
      const selectedFirstLevel = item.options.find((option) =>
        itemIdValueEqual({ formParams, itemId: item.itemId, value: option.value }),
      );

      if (selectedFirstLevel && selectedFirstLevel.children && Object.keys(selectedFirstLevel.children).length > 0) {
        // 設置選擇路徑，自動展開第二級

        selectedFirstLevel.itemId = item.itemId;
        selectedFirstLevel.parentItemId = parentItemId;
        setSelectionPath([selectedFirstLevel]);

        // 如果第二級也有選中項，可以繼續尋找
        if (selectedFirstLevel.children.options && selectedFirstLevel.children.itemId) {
          const selectedSecondLevel = selectedFirstLevel.children.options.find((option) =>
            itemIdValueEqual({ formParams, itemId: selectedFirstLevel.children.itemId, value: option.value }),
          );

          if (selectedSecondLevel) {
            selectedSecondLevel.itemId = selectedFirstLevel.children.itemId;
            selectedSecondLevel.parentItemId = parentItemId;
            setSelectionPath([selectedFirstLevel, selectedSecondLevel]);
          }
        }
      } else {
        setSelectionPath([]);
      }
    }
  }, [visible, formParams, item]);

  // 重置选择路径
  useEffect(() => {
    if (!visible) {
      setSelectionPath([]);
    }
  }, [visible]);

  if (!visible) return null;

  // 计算要显示的级联层级
  const renderLevels = () => {
    const levels = [];

    // 第一级始终显示原始选项
    if (item.options?.length > 0) {
      levels.push(
        <CascaderLevel
          formParams={formParams}
          itemId={item.itemId}
          parentItemId={parentItemId}
          key='level-0'
          options={item.options}
          onSelect={(e, option) => handleSelect(e, 0, option)}
        />,
      );
    }

    // 根据选择路径渲染后续级别
    selectionPath.forEach((selected, index) => {
      if (selected.children?.options?.length > 0) {
        levels.push(
          <CascaderLevel
            formParams={formParams}
            itemId={selected.children.itemId}
            parentItemId={parentItemId}
            key={`level-${index + 1}`}
            options={selected.children.options}
            onSelect={(e, option: any) => handleSelect(e, index + 1, option)}
          />,
        );
      }
    });

    return levels;
  };

  return <div className={`top-40 left-0 absolute z-[102] flex`}>{renderLevels()}</div>;
};

export default CascaderPopup;
